import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function Cursor() {
  const [hovering, setHovering] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(true); // default hidden

  const mouseX = useMotionValue(-100);
  const mouseY = useMotionValue(-100);
  const ringX = useSpring(mouseX, { damping: 20, stiffness: 200, mass: 0.8 });
  const ringY = useSpring(mouseY, { damping: 20, stiffness: 200, mass: 0.8 });

  useEffect(() => {
    // Only show cursor on non-touch devices (desktops/laptops)
    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    setIsTouchDevice(isTouch);
    if (isTouch) return; // don't attach any listeners on mobile

    const onMove = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
    };
    const onEnter = (e) => {
  if (e.target && e.target.closest && e.target.closest('a, button, input, select, textarea, [data-hover]')) {
        setHovering(true);
      }
    };
    const onLeave = (e) => {
  if (e.target && e.target.closest && e.target.closest('a, button, input, select, textarea, [data-hover]')) {
        setHovering(false);
      }
    };
    window.addEventListener('mousemove', onMove);
    document.addEventListener('mouseenter', onEnter, true);
    document.addEventListener('mouseleave', onLeave, true);
    return () => {
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseenter', onEnter, true);
      document.removeEventListener('mouseleave', onLeave, true);
    };
  }, [mouseX, mouseY]);

  // Don't render anything on touch/mobile devices
  if (isTouchDevice) return null;

  const cursorStyle = {
    position: 'fixed',
    top: 0, left: 0,
    pointerEvents: 'none',
    zIndex: 9999,
    translateX: '-50%',
    translateY: '-50%',
  };

  return (
    <>
      <motion.div
        style={{
          ...cursorStyle,
          x: mouseX,
          y: mouseY,
          width: hovering ? 18 : 10,
          height: hovering ? 18 : 10,
          borderRadius: '50%',
          background: hovering ? '#ffffff' : '#C8A96A',
          transition: 'width 0.22s ease, height 0.22s ease, background 0.22s ease',
        }}
      />
      <motion.div
        style={{
          ...cursorStyle,
          x: ringX,
          y: ringY,
          width: hovering ? 54 : 36,
          height: hovering ? 54 : 36,
          borderRadius: '50%',
          border: `1px solid ${hovering ? 'rgba(255,255,255,0.25)' : 'rgba(200,169,106,0.45)'}`,
          transition: 'width 0.28s ease, height 0.28s ease, border-color 0.28s ease',
          zIndex: 9998,
        }}
      />
    </>
  );
}
